import {AutorisationAggregate} from './autorisation.aggregate';
import {DroitModel} from '../../models/profils/droit.model';
import {Observable, of} from 'rxjs';
import {ContextDroitsModel} from '../../models/menu/context-droits.model';
import {Injector} from '@angular/core';
import {AutorisationContextuel} from './autorisation-contextuel.type';

export class AutorisationsAggregate {
  constructor(
    readonly autorisations: Array<AutorisationAggregate>,
    readonly autorisationContextuel?: AutorisationContextuel,
    private allAutorizationsRequired: boolean = false
  ) {}

  isAuthorizedForContext(context: ContextDroitsModel): Observable<boolean> {
    if (!this.isAuthorizedForDroits(context.droits)) {
      return of(false);
    }

    return this.isAuthorizedForAutorisationContextuel(context.injectorContext);
  }

  private isAuthorizedForDroits(droits: Array<DroitModel>): boolean {
    if (this.allAutorizationsRequired) {
      return this.autorisations.every(droit => droit.isAuthorizedForDroits(droits));
    }
    return this.autorisations.some(droit => droit.isAuthorizedForDroits(droits));
  }

  private isAuthorizedForAutorisationContextuel(injector: Injector): Observable<boolean> {
    if (!this.autorisationContextuel) {
      return of(true);
    }
    return this.autorisationContextuel(injector);
  }
}
